import Cookies from "js-cookie";
import { useRouter } from "next/router";
export function useRetentionCookie() {
  const router = useRouter();
  const affiliate = typeof router.query.affiliate === "string" ? router.query.affiliate : "";
  const retentionAffiliate = typeof router.query.retention_affiliate === "string" ? router.query.retention_affiliate : "";
  const affiliateValue = retentionAffiliate || affiliate;
  if (affiliateValue) {
    Cookies.set("retention_affiliate", affiliateValue);
  }
}